import { render, staticRenderFns } from "./Vgroup.vue?vue&type=template&id=25c6d484&"
import script from "./Vgroup.vue?vue&type=script&lang=js&"
export * from "./Vgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports